<template>
  <div class="JNPF-common-layout-footer">
    <p>© 中科华予（北京）健康医学研究院 | 京ICP备17003064号</p>
    <p>全国统一客服热线&nbsp;&nbsp;:&nbsp;&nbsp;<span>400-8484-833&nbsp;&nbsp;/&nbsp;&nbsp;028-87775609</span></p>
    <p>地址：北京市海淀区苏州街20号院1号楼银丰大厦1406</p>
  </div>
</template>

<script>
export default {
  name: "RAXFooter"
}
</script>

<style lang="scss" scoped>
.JNPF-common-layout-footer{
  width: 100%;
  padding: 40px 30px;
  background-color: #FFFFFF;
  border-top: 4px solid #0056A2;
  box-sizing: border-box;

  p{
    width: 100%;
    text-align: center;
    line-height: 20px;
    font-size: 14px;
    color: #545454;
    font-weight: 600;

    & + p{
      margin-top: 8px;
    }

    span{
      color: #0056A2;
      font-weight: 600;
    }
  }
}
</style>
